import React from "react";
import EmptyCompanyCreditData from "components/EmptyCompanyCreditData";
import EmptyData from "components/EmptyData";

const EmptyOrNoCompanyCreditData = ({hasFirstUpdateData}) => {
  return hasFirstUpdateData ? <EmptyData /> : <EmptyCompanyCreditData addClass="fz-14" />;
};

export default EmptyOrNoCompanyCreditData;
